import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'

export default class Title extends Component {
  static propTypes = {
    children: PropTypes.string,
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    const { children } = this.props
    return (
      <Helmet
        titleTemplate="%s | ThinkCERCA"
        defaultTitle="Personalized Literacy Program"
      >
        {children && <title>{children}</title>}
      </Helmet>
    )
  }
}
